export const UNIT = 'NXPC'
export const TOKEN_UNIT = 'NESO'